// src/reducers/deliveryReducer.js

import { types } from '../types/types';

const initialState = {
    editingDelivery: {
        id: 0,
        customerFk: 0,
        status: true,
        ordinal: 0,
        message: '',
        attended: '',
        process: 0,
        label: '',
        realmFk: ''
    }
};

export const deliveryReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.editingDeliveryInfo:
            return {
                ...state,
                editingDelivery: action.payload,
            };

        case types.clearDeliveryInfo:
            return {
                ...state,
                editingDelivery: initialState.editingDelivery,
            };

        default:
            return state;
    }
};